import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UploadImgComponent }  from './upload-Img';
import { DownloadImgComponent } from './download-Img';
import { SharedModule } from '../shared/shared.module';
import { SpinvalueComponent } from './spinvalue/spinvalue.component';
import { LabelTitleComponent } from './labelTitle';
import {SectionBottomComponent,SectionContentComponent,
  ContainerComponent,
  SectionTitleComponent,SectionHeaderComponent} from './sections';
import { FormSaveComponent }  from './form-save';
import {VerticalFormSaveComponent,HorizontalFormSaveComponent } from './vertical-form-save';
import { MatInputSearchComponent } from './mat-input-search/mat-input-search.component';  
import {FormsModule} from '@angular/forms'


export function formatMoney(num: number, c: number = 2, d: string = ',', t: string = '.', simbol?: string): string {
  if (simbol == null)
    simbol = '';
  var n = num,
    c = isNaN(c = Math.abs(c)) ? 2 : c,
    d = d == undefined ? "." : d,
    t = t == undefined ? "," : t,
    s = n < 0 ? "-" : "",
    n = Math.abs(+n || 0),
    i = parseInt(n.toFixed(c)) + "",
    j = (j = i.length) > 3 ? j % 3 : 0;
  return simbol + s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - (<any>i)).toFixed(c).slice(2) : "");
};

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    FormsModule
  ],
  declarations: [
    UploadImgComponent,DownloadImgComponent, SpinvalueComponent,LabelTitleComponent,
    SectionBottomComponent,SectionContentComponent,
    SectionTitleComponent,SectionHeaderComponent,
    ContainerComponent,
    FormSaveComponent,
    VerticalFormSaveComponent,
    HorizontalFormSaveComponent,
    MatInputSearchComponent,
    
  ],
  exports:[
    UploadImgComponent,DownloadImgComponent,LabelTitleComponent,
    SectionBottomComponent,SectionContentComponent,
    SectionTitleComponent,SectionHeaderComponent,
    ContainerComponent,
    FormSaveComponent,
    VerticalFormSaveComponent,
    HorizontalFormSaveComponent,
    MatInputSearchComponent
  ]
})
export class ControlsModule { }
